export default {"src":"/_next/static/media/webcam.da7a289b.svg","height":68,"width":67,"blurWidth":0,"blurHeight":0};